const state = () => ({
  boards: [],
});

const getters = {
  all: state => state.boards,
  enabled: (state, getters, rootState, rootGetters) => rootGetters['user/featureEnabled']('featureDiscussionBoard'),
  find: state => id => state.boards.find(board => board.id === Number(id)),
};

const mutations = {
  setBoards(state, boards) {
    state.boards = boards;
  },
  setBoard(state, board) {
    const others = state.boards.filter(b => b.id !== board.id);
    state.boards = [...others, board].sort((a, b) => a.position - b.position || a.id - b.id);
  },
};

const actions = {
  fetchBoards({ commit, rootGetters }) {
    return rootGetters['session/ajax'].get('/discussion_boards').then(response => {
      commit('setBoards', response.data.discussionBoards);
      return response.data.discussionBoards;
    });
  },
  fetchBoard({ commit, rootGetters }, id) {
    return rootGetters['session/ajax'].get(`/discussion_boards/${id}`).then(response => {
      commit('setBoard', response.data.discussionBoard);
      return response.data.discussionBoard;
    });
  },
  // Resolves to { threads, totalCount, limit, offset }
  fetchThreads({ rootGetters }, { boardId, sort = 'recent', limit = 20, offset = 0 }) {
    const params = { sort, limit, offset };
    return rootGetters['session/ajax'].get(`/discussion_boards/${boardId}/threads`, { params }).then(response => {
      return { threads: response.data.threads, ...response.data.meta };
    });
  },
  // Resolves to { questions, totalCount, limit, offset }
  fetchQuestionActivity({ rootGetters }, { sort = 'recent', limit = 20, offset = 0 } = {}) {
    const params = { sort, limit, offset };
    return rootGetters['session/ajax'].get('/discussion_boards/questions', { params }).then(response => {
      return { questions: response.data.questions, ...response.data.meta };
    });
  },
  // Resolves to { discussions, totalCount, limit, offset } for the current user's discussions
  fetchMyDiscussions({ rootGetters }, { sort = 'newest', limit = 20, offset = 0 } = {}) {
    const params = { sort, limit, offset };
    return rootGetters['session/ajax'].get('/discussions/manage', { params }).then(response => {
      return { discussions: response.data.discussions, ...response.data.meta };
    });
  },
  // Resolves to the thread starter discussion
  createThread({ dispatch }, { boardId, title, message }) {
    return dispatch('discussions/createDiscussion', { discussionBoardId: boardId, title, message }, { root: true });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
